import { render, staticRenderFns } from "./GeneralManagementTab.vue?vue&type=template&id=70b1a366"
import script from "./GeneralManagementTab.vue?vue&type=script&lang=js"
export * from "./GeneralManagementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports